"use strict";

import { campaignConstants } from "../_constants";

export const campaignGetLatestCampaignRequest = (payload) => {
    return {
        type: campaignConstants.CAMPAIGN_GET_LATEST_CAMPAIGN_REQUEST,
        payload,
    };
};

export const campaignGetLatestCampaignComplete = (payload) => {
    return {
        type: campaignConstants.CAMPAIGN_GET_LATEST_CAMPAIGN_COMPLETE,
        payload,
    };
};

export const getHomeCarouselCampaignRequest = (payload) => {
    return {
        type: campaignConstants.GET_HOME_CAROUSEL_CAMPAIGN_REQUEST,
        payload,
    };
};

export const getHomeCarouselCampaignComplete = (payload) => {
    return {
        type: campaignConstants.GET_HOME_CAROUSEL_CAMPAIGN_COMPLETE,
        payload,
    };
};

export const campaignHomeGetBestVoucherDealsTodayRequest = (payload) => {
    return {
        type: campaignConstants.GET_HOME_BEST_VOUCHER_DEALS_TODAY_REQUEST,
        payload,
    };
};

export const campaignHomeGetBestVoucherDealsTodayComplete = (payload) => {
    return {
        type: campaignConstants.GET_HOME_BEST_VOUCHER_DEALS_TODAY_COMPLETE,
        payload,
    };
};

export const campaignHomeGetTrendingVouchersRequest = (payload) => {
    return {
        type: campaignConstants.GET_HOME_TRENDING_VOUCHER_REQUEST,
        payload,
    };
};

export const campaignHomeGetTrendingVouchersComplete = (payload) => {
    return {
        type: campaignConstants.GET_HOME_TRENDING_VOUCHER_COMPLETE,
        payload,
    };
};

export const campaignGetFeaturedCampaignBannersRequest = (payload) => {
    return {
        type: campaignConstants.GET_FEATURED_CAMPAIGN_BANNERS_REQUEST,
        payload,
    };
};

export const campaignGetFeaturedCampaignBannersComplete = (payload) => {
    return {
        type: campaignConstants.GET_FEATURED_CAMPAIGN_BANNERS_COMPLETE,
        payload,
    };
};

export const campaignGetCampaignDetailsRequest = (payload) => {
    return {
        type: campaignConstants.GET_CAMPAIGN_DETAILS_REQUEST,
        payload,
    };
};

export const campaignGetCampaignDetailsComplete = (payload) => {
    return {
        type: campaignConstants.GET_CAMPAIGN_DETAILS_COMPLETE,
        payload,
    };
};

export const campaignTokenValidationRequest = (payload) => {
    return {
        type: campaignConstants.CAMPAIGN_SPINWIN_TOKEN_VALIDATION_REQUEST,
        payload,
    };
};

export const campaignTokenValidationComplete = (payload) => {
    return {
        type: campaignConstants.CAMPAIGN_SPINWIN_TOKEN_VALIDATION_COMPLETE,
        payload,
    };
};

export const campaignTokenValidationError = (payload) => {
    return {
        type: campaignConstants.CAMPAIGN_SPINWIN_TOKEN_VALIDATION_ERROR,
        payload,
    };
};

export const campaignSpinwinGetDataRequest = (payload) => {
    return {
        type: campaignConstants.CAMPAIGN_SPINWIN_GET_DATA_REQUEST,
        payload,
    };
};

export const campaignSpinwinGetDataComplete = (payload) => {
    return {
        type: campaignConstants.CAMPAIGN_SPINWIN_GET_DATA_COMPLETE,
        payload,
    };
};

export const campaignSpinwinGetInitialDataRequest = (payload) => {
    return {
        type: campaignConstants.CAMPAIGN_SPINWIN_GET_INITIAL_DATA_REQUEST,
        payload,
    };
};

export const campaignSpinwinGetInitialDataComplete = (payload) => {
    return {
        type: campaignConstants.CAMPAIGN_SPINWIN_GET_INITIAL_DATA_COMPLETE,
        payload,
    };
};

export const joingIncentiveDataRequest = (payload) => {
    return {
        type: campaignConstants.JOING_INCENTIVE_DATA_REQUEST,
        payload,
    };
};

export const joingIncentiveDataComplete = (payload) => {
    return {
        type: campaignConstants.JOING_INCENTIVE_DATA_COMPLETE,
        payload,
    };
};

export const spinWheelTokenReset = () => {
    return {
        type: campaignConstants.SPINWHEEL_TOKEN_RESET,
    };
};

export const campaignHomeBannersRequest = (payload) => {
    return {
        type: campaignConstants.CAMPAIGN_HOME_BANNERS_REQUEST,
        payload,
    };
};

export const campaignHomeBannersComplete = (payload) => {
    return {
        type: campaignConstants.CAMPAIGN_HOME_BANNERS_COMPLETE,
        payload,
    };
};

export const campaignVoucherAddToFavouriteRequest = (payload) => {
    return {
        type: campaignConstants.CAMPAIGN_VOUCHER_ADDTO_FAVOURITE_REQUEST,
        payload,
    };
};

export const campaignVoucherAddToFavouriteComplete = (payload) => {
    return {
        type: campaignConstants.CAMPAIGN_VOUCHER_ADDTO_FAVOURITE_COMPLETE,
        payload,
    };
};

export const campaignVoucherRemoveFromFavouriteRequest = (payload) => {
    return {
        type: campaignConstants.CAMPAIGN_VOUCHER_REMOVEFROM_FAVOURITE_REQUEST,
        payload,
    };
};

export const campaignVoucherRemoveFromFavouriteComplete = (payload) => {
    return {
        type: campaignConstants.CAMPAIGN_VOUCHER_REMOVEFROM_FAVOURITE_COMPLETE,
        payload,
    };
};

export const getCampaignLeagueTableRequest = (payload) => {
    return {
        type: campaignConstants.GET_CAMPAIGN_LEAGUE_TABLE_REQUEST,
        payload,
    };
};

export const getCampaignLeagueTableComplete = (payload) => {
    return {
        type: campaignConstants.GET_CAMPAIGN_LEAGUE_TABLE_COMPLETE,
        payload,
    };
};

export const getParticipantSalesRequest = (payload) => {
    return {
        type: campaignConstants.GET_PARTICIPANT_SALES_REQUEST,
        payload,
    };
};

export const getParticipantSalesComplete = (payload) => {
    return {
        type: campaignConstants.GET_PARTICIPANT_SALES_COMPLETE,
        payload,
    };
};

export const campaignPrizeDrawDetailsRequest = (payload) => {
    return {
        type: campaignConstants.GET_CAMPAIGN_PRIZEDRAW_DETAILS_REQUEST,
        payload,
    };
};

export const campaignPrizeDrawDetailsComplete = (payload) => {
    return {
        type: campaignConstants.GET_CAMPAIGN_PRIZEDRAW_DETAILS_COMPLETE,
        payload,
    };
};

export const addPrizeDrawCampaignEntryRequest = (payload) => {
    return {
        type: campaignConstants.ADD_PRIZE_DRAW_CAMPAIGN_ENTRY_DATA_REQUEST,
        payload,
    };
};

export const addPrizeDrawCampaignEntryComplete = (payload) => {
    return {
        type: campaignConstants.ADD_PRIZE_DRAW_CAMPAIGN_ENTRY_DATA_COMPLETE,
        payload,
    };
};

export const getLeagueIndividualDetailsRequest = (payload) => {
    return {
        type: campaignConstants.GET_LEAGUE_INDIVIDUAL_DETAILS_DATA_REQUEST,
        payload,
    };
};

export const getLeagueIndividualDetailsComplete = (payload) => {
    return {
        type: campaignConstants.GET_LEAGUE_INDIVIDUAL_DETAILS_DATA_COMPLETE,
        payload,
    };
};

export const getLeagueTeamDetailsRequest = (payload) => {
    return {
        type: campaignConstants.GET_LEAGUE_TEAM_DETAILS_DATA_REQUEST,
        payload,
    };
};

export const getLeagueTeamDetailsComplete = (payload) => {
    return {
        type: campaignConstants.GET_LEAGUE_TEAM_DETAILS_DATA_COMPLETE,
        payload,
    };
};

export const submitLeagueTeamParticipantRequest = (payload) => {
    return {
        type: campaignConstants.SUBMIT_LEAGUE_TEAM_PARTICIPANT_REQUEST,
        payload,
    };
};

export const submitLeagueTeamParticipantComplete = (payload) => {
    return {
        type: campaignConstants.SUBMIT_LEAGUE_TEAM_PARTICIPANT_COMPLETE,
        payload,
    };
};

export const getCommsDetailsRequest = (payload) => {
    return {
        type: campaignConstants.GET_COMMS_DETAILS_REQUEST,
        payload,
    };
};

export const getCommsDetailsComplete = (payload) => {
    return {
        type: campaignConstants.GET_COMMS_DETAILS_COMPLETE,
        payload,
    };
};

export const campaignGetWareAndTireSummaryRequest = (payload) => {
    return {
        type: campaignConstants.CAMPAIGN_GET_WARE_AND_TIRE_SUMMARY_REQUEST,
        payload,
    };
};

export const campaignGetWareAndTireSummaryComplete = (payload) => {
    return {
        type: campaignConstants.CAMPAIGN_GET_WARE_AND_TIRE_SUMMARY_COMPLETE,
        payload,
    };
};

export const campaignGetLeagueTableSummaryRequest = (payload) => {
    return {
        type: campaignConstants.CAMPAIGN_GET_LEAGUE_TABLE_SUMMARY_REQUEST,
        payload,
    };
};

export const campaignGetLeagueTableSummaryComplete = (payload) => {
    return {
        type: campaignConstants.CAMPAIGN_GET_LEAGUE_TABLE_SUMMARY_COMPLETE,
        payload,
    };
};


export const campaignGetLeagueTableSummaryDropDownRequest = (payload) => {
    return {
        type: campaignConstants.CAMPAIGN_GET_LEAGUE_TABLE_SUMMARY_DROP_DOWN_REQUEST,
        payload,
    };
};

export const campaignGetLeagueTableSummaryDropDownComplete = (payload) => {
    return {
        type: campaignConstants.CAMPAIGN_GET_LEAGUE_TABLE_SUMMARY_DROP_DOWN_COMPLETE,
        payload,
    };
};




export const campaignGetParticipantIncentiveRequest = (payload) => {
    return {
        type: campaignConstants.CAMPAIGN_GET_PARTICIPANT_ACTIVE_CAMPAIGNS_REQUEST,
        payload,
    };
};

export const campaignGetParticipantIncentiveComplete = (payload) => {
    return {
        type: campaignConstants.CAMPAIGN_GET_PARTICIPANT_ACTIVE_CAMPAIGNS_COMPLETE,
        payload,
    };
};

export const campaignGetParticipantIncentiveCampaignPerformanceMetricsRequest =
    (payload) => {
        return {
            type: campaignConstants.CAMPAIGN_GET_PARTICIPANT_INCENTIVE_PERFORMANCE_METRICS_REQUEST,
            payload,
        };
    };

export const campaignGetParticipantIncentiveCampaignPerformanceMetricsComplete =
    (payload) => {
        return {
            type: campaignConstants.CAMPAIGN_GET_PARTICIPANT_INCENTIVE_PERFORMANCE_METRICS_COMPLETE,
            payload,
        };
    };

export const campaignParticipantIncentiveCampaignPerformanceMetricsClear =
    () => {
        return {
            type: campaignConstants.CAMPAIGN_PARTICIPANT_INCENTIVE_PERFORMANCE_METRICS_CLEAR,
        };
    };

export const campaignParticipantIncentiveClear = () => {
    return {
        type: campaignConstants.CAMPAIGN_PARTICIPANT_ACTIVE_CAMPAIGNS_CLEAR,
    };
};

export const campaignGetCastrolLeagueTableSummaryRequest = (payload) => {
    return {
        type: campaignConstants.CAMPAIGN_GET_CASTROL_LEAGUE_TABLE_SUMMARY_REQUEST,
        payload,
    };
};

export const campaignGetCastrolLeagueTableSummaryComplete = (payload) => {
    return {
        type: campaignConstants.CAMPAIGN_GET_CASTROL_LEAGUE_TABLE_SUMMARY_COMPLETE,
        payload,
    };
};

export const campaignPageLogPageViewRequest = (payload) => {
    return {
        type: campaignConstants.CAMPAIGN_PAGE_LOG_PAGE_VIEW_REQUEST,
        payload,
    };
};

export const campaignPageLogPageViewComplete = (payload) => {
    return {
        type: campaignConstants.CAMPAIGN_PAGE_LOG_PAGE_VIEW_COMPLETE,
        payload,
    };
};

export const campaignLikeContentPageRequest = (payload) => {
    return {
        type: campaignConstants.CAMPAIGN_PAGE_LIKE_CONTENT_REQUEST,
        payload,
    };
};

export const campaignLikeContentPageComplete = (payload) => {
    return {
        type: campaignConstants.CAMPAIGN_PAGE_LIKE_CONTENT_COMPLETE,
        payload,
    };
};

export const campaignLikeSummaryRequest = (payload) => {
    return {
        type: campaignConstants.CAMPAIGN_PAGE_LIKE_SUMMARY_REQUEST,
        payload,
    };
};

export const campaignLikeSummaryComplete = (payload) => {
    return {
        type: campaignConstants.CAMPAIGN_PAGE_LIKE_SUMMARY_COMPLETE,
        payload,
    };
};

export const campaignGetAreaManagerDealersRequest = (payload) => {
    return {
        type: campaignConstants.CAMPAIGN_GET_AREA_MANAGERS_DEALERS_REQUEST,
        payload,
    };
};

export const campaignGetAreaManagerDealersComplete = (payload) => {
    return {
        type: campaignConstants.CAMPAIGN_GET_AREA_MANAGERS_DEALERS_COMPLETE,
        payload,
    };
};

export const campaignGetParticipantsByDealerRequest = (payload) => {
    return {
        type: campaignConstants.CAMPAIGN_GET_PARTICIPANTS_BY_DEALERS_REQUEST,
        payload,
    };
};

export const campaignGetParticipantsByDealerComplete = (payload) => {
    return {
        type: campaignConstants.CAMPAIGN_GET_PARTICIPANTS_BY_DEALERS_COMPLETE,
        payload,
    };
};

export const campaignGetPerformanceMetricsByDealerRequest = (payload) => {
    return {
        type: campaignConstants.CAMPAIGN_GET_PERFORMANCE_METRICS_BY_DEALERS_REQUEST,
        payload,
    };
};

export const campaignGetPerformanceMetricsByDealerComplete = (payload) => {
    return {
        type: campaignConstants.CAMPAIGN_GET_PERFORMANCE_METRICS_BY_DEALERS_COMPLETE,
        payload,
    };
};


export const campaignGetPerformanceMetricsByDealerDropDownRequest = (payload) => {
    return {
        type: campaignConstants.CAMPAIGN_GET_PERFORMANCE_METRICS_BY_DEALERS_DROP_DOWN_REQUEST,
        payload,
    };
};

export const campaignGetPerformanceMetricsByDealerDropDownComplete = (payload) => {
    return {
        type: campaignConstants.CAMPAIGN_GET_PERFORMANCE_METRICS_BY_DEALERS_DROP_DOWN_COMPLETE,
        payload,
    };
};



export const campaignGetAreaManagersLeaguesRankSummaryRequest = (payload) => {
    return {
        type: campaignConstants.CAMPAIGN_GET_AREA_MANAGER_LEAGUES_RANK_SUMMARY_REQUEST,
        payload,
    };
};

export const campaignGetAreaManagersLeaguesRankSummaryComplete = (payload) => {
    return {
        type: campaignConstants.CAMPAIGN_GET_AREA_MANAGER_LEAGUES_RANK_SUMMARY_COMPLETE,
        payload,
    };
};

export const campaignGetCastrolLeagueQ4TableSummaryRequest = (payload) => {
    return {
        type: campaignConstants.CAMPAIGN_GET_CASTROL_LEAGUE_TABLE_Q4_SUMMARY_REQUEST,
        payload,
    };
};

export const campaignGetCastrolLeagueQ4TableSummaryComplete = (payload) => {
    return {
        type: campaignConstants.CAMPAIGN_GET_CASTROL_LEAGUE_TABLE_Q4_SUMMARY_COMPLETE,
        payload,
    };
};

export const campaignGetServiceManagersLeaguesBonusRankBatterySummaryRequest = (
    payload,
) => {
    return {
        type: campaignConstants.CAMPAIGN_GET_SERVICE_MANAGER_LEAGUES_BONUS_RANK_BATTERY_SUMMARY_REQUEST,
        payload,
    };
};

export const campaignGetServiceManagersLeaguesBonusRankBatterySummaryComplete =
    (payload) => {
        return {
            type: campaignConstants.CAMPAIGN_GET_SERVICE_MANAGER_LEAGUES_BONUS_RANK_BATTERY_SUMMARY_COMPLETE,
            payload,
        };
    };

export const campaignGetServiceManagersLeaguesBonusRankBatterySummaryDropDownRequest = (payload) => {
    return {
        type: campaignConstants.CAMPAIGN_GET_SERVICE_MANAGER_LEAGUES_BONUS_RANK_BATTERY_SUMMARY_DROP_DOWN_REQUEST,
        payload,
    };
};

export const campaignGetServiceManagersLeaguesBonusRankBatterySummaryDropDownComplete = (payload) => {
        return {
            type: campaignConstants.CAMPAIGN_GET_SERVICE_MANAGER_LEAGUES_BONUS_RANK_BATTERY_SUMMARY_DROP_DOWN_COMPLETE,
            payload,
        };
    };



export const campaignGetServiceManagersLeaguesBonusRankBrakePadsSummaryRequest =
    (payload) => {
        return {
            type: campaignConstants.CAMPAIGN_GET_SERVICE_MANAGER_LEAGUES_BONUS_RANK_BRAKE_PADS_SUMMARY_REQUEST,
            payload,
        };
    };

export const campaignGetServiceManagersLeaguesBonusRankBrakePadsSummaryComplete =
    (payload) => {
        return {
            type: campaignConstants.CAMPAIGN_GET_SERVICE_MANAGER_LEAGUES_BONUS_RANK_BRAKE_PADS_SUMMARY_COMPLETE,
            payload,
        };
    };

export const campaignGetServiceManagersLeaguesBonusRankWiperBladeSummaryRequest =
    (payload) => {
        return {
            type: campaignConstants.CAMPAIGN_GET_SERVICE_MANAGER_LEAGUES_BONUS_RANK_WIPER_BLADE_SUMMARY_REQUEST,
            payload,
        };
    };

export const campaignGetServiceManagersLeaguesBonusRankWiperBladeSummaryComplete =
    (payload) => {
        return {
            type: campaignConstants.CAMPAIGN_GET_SERVICE_MANAGER_LEAGUES_BONUS_RANK_WIPER_BLADE_SUMMARY_COMPLETE,
            payload,
        };
    };

export const campaignGetServiceManagersLeaguesBonusRankBrakeDiscsSummaryRequest =
    (payload) => {
        return {
            type: campaignConstants.CAMPAIGN_GET_SERVICE_MANAGER_LEAGUES_BONUS_RANK_BRAKE_DISCS_SUMMARY_REQUEST,
            payload,
        };
    };

export const campaignGetServiceManagersLeaguesBonusRankBrakeDiscsSummaryComplete =
    (payload) => {
        return {
            type: campaignConstants.CAMPAIGN_GET_SERVICE_MANAGER_LEAGUES_BONUS_RANK_BRAKE_DISCS_SUMMARY_COMPLETE,
            payload,
        };
    };

export const campaignGetServiceManagersLeaguesBonusRankAreaTopPerformerSummaryRequest =
    (payload) => {
        return {
            type: campaignConstants.CAMPAIGN_GET_SERVICE_MANAGER_LEAGUES_BONUS_RANK_AREA_TOP_SUMMARY_REQUEST,
            payload,
        };
    };

export const campaignGetServiceManagersLeaguesBonusRankAreaTopPerformerSummaryComplete =
    (payload) => {
        return {
            type: campaignConstants.CAMPAIGN_GET_SERVICE_MANAGER_LEAGUES_BONUS_RANK_AREA_TOP_SUMMARY_COMPLETE,
            payload,
        };
    };

export const campaignGetLeagueNationalTopPerformerSummaryRequest = (
    payload,
) => {
    return {
        type: campaignConstants.CAMPAIGN_GET_LEAGUE_NATIONAL_TOP_PERFORMER_SUMMARY_REQUEST,
        payload,
    };
};

export const campaignGetLeagueNationalTopPerformerSummaryComplete = (
    payload,
) => {
    return {
        type: campaignConstants.CAMPAIGN_GET_LEAGUE_NATIONAL_TOP_PERFORMER_SUMMARY_COMPLETE,
        payload,
    };
};


export const campaignGetLeagueNationalTopPerformerSummaryDropDownRequest = (payload) => {
    return {
        type: campaignConstants.CAMPAIGN_GET_LEAGUE_NATIONAL_TOP_PERFORMER_SUMMARY_DROP_DOWN_REQUEST,
        payload,
    };
};

export const campaignGetLeagueNationalTopPerformerSummaryDropDownComplete = (payload) => {
    return {
        type: campaignConstants.CAMPAIGN_GET_LEAGUE_NATIONAL_TOP_PERFORMER_SUMMARY_DROP_DOWN_COMPLETE,
        payload,
    };
};



export const getTlcCustomerRequest = (payload) => {
    return {
        type: campaignConstants.GET_TLC_CUSTOMER_REQUEST,
        payload,
    };
};

export const getTlcCustomerComplete = (payload) => {
    return {
        type: campaignConstants.GET_TLC_CUSTOMER_COMPLETE,
        payload,
    };
};

export const getGoldRushCampaignPerformanceSummaryRequest = (payload) => {
    return {
        type: campaignConstants.GET_GOLD_RUSH_CAMPAIGN_PERFORMANCE_SUMMARY_REQUEST,
        payload,
    };
};

export const getGoldRushCampaignPerformanceSummaryComplete = (payload) => {
    return {
        type: campaignConstants.GET_GOLD_RUSH_CAMPAIGN_PERFORMANCE_SUMMARY_COMPLETE,
        payload,
    };
};

export const getCastrolDealerPerformanceSummaryRequest = (payload) => {
    return {
        type: campaignConstants.GET_CASTROL_DEALER_PERFORMANCE_SUMMARY_REQUEST,
        payload,
    };
};

export const getCastrolDealerPerformanceSummaryComplete = (payload) => {
    return {
        type: campaignConstants.GET_CASTROL_DEALER_PERFORMANCE_SUMMARY_COMPLETE,
        payload,
    };
};

export const campaignGetTlcRetailersRequest = (payload) => {
    return {
        type: campaignConstants.TLC_GET_TLC_RETAILERS_REQUEST,
        payload,
    };
};

export const campaignGetTlcRetailersComplete = (payload) => {
    return {
        type: campaignConstants.TLC_GET_TLC_RETAILERS_COMPLETE,
        payload,
    };
};

export const campaignGetServiceStartLeagueRankSummaryRequest = (payload) => {
    return {
        type: campaignConstants.CAMPAIGN_SERVICE_STAR_GET_SERVICE_STAR_LEAGUE_RANK_SUMMARY_REQUEST,
        payload,
    };
};

export const campaignGetServiceStartLeagueRankSummaryComplete = (payload) => {
    return {
        type: campaignConstants.CAMPAIGN_SERVICE_STAR_GET_SERVICE_STAR_LEAGUE_RANK_SUMMARY_COMPLETE,
        payload,
    };
};

export const campaignGetWearAndTearTeamPerformanceSummaryRequest = (payload) => {
    return {
        type: campaignConstants.CAMPAIGN_GET_WEAR_AND_TEAR_TEAM_PERFORMANCE_SUMMARY_REQUEST,
        payload,
    };
};

export const campaignGetWearAndTearTeamPerformanceSummaryComplete = (payload) => {
    return {
        type: campaignConstants.CAMPAIGN_GET_WEAR_AND_TEAR_TEAM_PERFORMANCE_SUMMARY_COMPLETE,
        payload,
    };
};

export const campaignGetWinningSpinDataRequest = (payload) => {
    return {
        type: campaignConstants.CAMPAIGN_GET_WINNING_SPIN_DATA_REQUEST,
        payload,
    };
};

export const campaignGetWinningSpinDataComplete = (payload) => {
    return {
        type: campaignConstants.CAMPAIGN_GET_WINNING_SPIN_DATA_COMPLETE,
        payload,
    };
};

export const campaignGetAlpineRewardSummaryRequest = (payload) => {
    return {
        type: campaignConstants.CAMPAIGN_GET_ALPINE_REWARD_SUMMARY_REQUEST,
        payload,
    };
};

export const campaignGetAlpineRewardSummaryComplete = (payload) => {
    return {
        type: campaignConstants.CAMPAIGN_GET_ALPINE_REWARD_SUMMARY_COMPLETE,
        payload,
    };
};

export const campaignGetTradePartsManagerSalesSummaryRequest = (payload) => {
    return {
        type: campaignConstants.CAMPAIGN_GET_TRADE_PARTS_MANAGER_INCENTIVE_REQUEST,
        payload,
    };
};

export const campaignGetTradePartsManagerSalesSummaryComplete = (payload) => {
    return {
        type: campaignConstants.CAMPAIGN_GET_TRADE_PARTS_MANAGER_INCENTIVE_COMPLETE,
        payload,
    };
};

export const campaignGetCastrolMotoLeaguesRankSummaryRequest = (payload) => {
    return {
        type: campaignConstants.CAMPAIGN_GET_CASTROL_MOTO_GP_LEAGUES_RANK_SUMMARY_REQUEST,
        payload,
    };
};

export const campaignGetCastrolMotoLeaguesRankSummaryComplete = (payload) => {
    return {
        type: campaignConstants.CAMPAIGN_GET_CASTROL_MOTO_GP_LEAGUES_RANK_SUMMARY_COMPLETE,
        payload,
    };
};

export const campaignGetTLCCustomerByDealersRequest = (payload) => {
    return {
        type: campaignConstants.CAMPAIGN_GET_TLC_CUSTOMER_BY_DEALERS_REQUEST,
        payload,
    };
};

export const campaignGetTLCCustomerByDealersComplete = (payload) => {
    return {
        type: campaignConstants.CAMPAIGN_GET_TLC_CUSTOMER_BY_DEALERS_COMPLETE,
        payload,
    };
};

export const campaignGetFullThrottleLeagueRankSummaryRequest = (payload) => {
    return {
        type: campaignConstants.CAMPAIGN_GET_FULL_THROTTLE_LEAGUE_RANK_SUMMARY_REQUEST,
        payload,
    };
};

export const campaignGetFullThrottleLeagueRankSummaryComplete = (payload) => {
    return {
        type: campaignConstants.CAMPAIGN_GET_FULL_THROTTLE_LEAGUE_RANK_SUMMARY_COMPLETE,
        payload,
    };
};

export const campaignGoldenTicketScratchCardDataRequest = (payload) => {
    return {
        type: campaignConstants.CAMPAIGN_GOLDEN_TICKET_SCRATCH_CARD_DATA_REQUEST,
        payload,
    };
};

export const campaignGoldenTicketScratchCardDataComplete = (payload) => {
    return {
        type: campaignConstants.CAMPAIGN_GOLDEN_TICKET_SCRATCH_CARD_DATA_COMPLETE,
        payload,
    };
};

export const campaignGoldenTicketClaimScratchCardCodeRequest = (payload) => {
    return {
        type: campaignConstants.CAMPAIGN_GOLDEN_TICKET_CLAIM_SCRATCH_CARD_CODE_REQUEST,
        payload,
    };
};

export const campaignGoldenTicketClaimScratchCardCodeComplete = (payload) => {
    return {
        type: campaignConstants.CAMPAIGN_GOLDEN_TICKET_CLAIM_SCRATCH_CARD_CODE_COMPLETE,
        payload,
    };
};

export const campaignVoteRewardPreferencesRequest = (payload) => {
    return {
        type: campaignConstants.CAMPAIGN_VOTE_REWARD_PREFERENCES_REQUEST,
        payload,
    };
};

export const campaignVoteRewardPreferencesComplete = (payload) => {
    return {
        type: campaignConstants.CAMPAIGN_VOTE_REWARD_PREFERENCES_COMPLETE,
        payload,
    };
};



export const campaignVChangeRole = (payload) => {
    return {
        type: campaignConstants.CAMPAIGN_CHANGE_ROLE,
        payload,
    };
};
export const campaignGetAllAreaManagerDealersRequest = (payload) => {
    return {
        type: campaignConstants.CAMPAIGN_GET_ALL_AREA_MANAGERS_DEALERS_REQUEST,
        payload,
    };
};
export const campaignGetAllAreaManagerDealersComplete = (payload) => {
    return {
        type: campaignConstants.CAMPAIGN_GET_ALL_AREA_MANAGERS_DEALERS_COMPLETE,
        payload,
    };
};